const LEGACY_EXTRAS_KEY = 'extras'

/** Lift a v1 `extras` bag onto the object. Keys already on the object win. */
export function unwrapLegacyExtras(json: unknown): unknown {
  if (!json || typeof json !== 'object' || Array.isArray(json)) {
    return json
  }

  const record = json as Record<string, unknown>
  const extras = record[LEGACY_EXTRAS_KEY]
  if (!extras || typeof extras !== 'object' || Array.isArray(extras)) {
    return json
  }

  const rest = { ...record }
  delete rest[LEGACY_EXTRAS_KEY]
  return { ...(extras as Record<string, unknown>), ...rest }
}
